import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { GoogleLogin } from 'react-google-login';
import GoogleIcon from '../assets/img/g-logo.png'

const { REACT_APP_URI = '/' } = process.env

const GoogleSignIn = (props) => {
    const { user: { condition, token }, messages } = props
    const responseGoogle = (response) => {
        const { accessToken } = response
        fetch(`${REACT_APP_URI}/accounts/socialAuth/google-oauth2/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ accessToken: accessToken })
            })
            .then(res => res.json())
            .then(res => props.dispatch({ type: 'setToken', token: res.token }))
            .then(() => window.location.reload())
            // .then(() => window.location.href = "/")
    }
    return (
        <StyledGoogleLogin
            clientId="178003956306-vu6q3dij0b7cruau209564v6cho8nkbl.apps.googleusercontent.com"
            onSuccess={responseGoogle}
            onFailure={responseGoogle}
        >
        <img src={GoogleIcon} alt=''/>
        <span>{condition === 'signIn' ? messages.nav_googlelogin : messages.user_googlesignup}</span>
        </StyledGoogleLogin>
    )
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(GoogleSignIn));

const StyledGoogleLogin = styled(GoogleLogin)`
    @import url('https://fonts.googleapis.com/css?family=Roboto');
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 8px;
    margin-bottom: 24px;
    border: 0;
    border-radius: 1px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);  
    background-color: #fff;
    font-family: 'Roboto', sans-serif;
    color: #757575;
    cursor: pointer;
    outline: none;
    &:hover {
        box-shadow: 0 0 3px 3px rgba(66,133,244,.3);
    }
    span {
        font-size: 14px;
        line-height: 14px;
    }
    img {
        width: 18px;
        margin-right: 16px;
    }
`


// WEBPACK FOOTER //
// ./src/User/GoogleSignIn.js